import { FC } from "react";
import { StyledSeparator } from "./styled";

type SeparatorProps = {};

const Separator: FC<SeparatorProps> = () => {
  return <StyledSeparator />;
};

export default Separator;
